export default {
  fields: {
    invoice_id: {
      readOnly: true,
    },
    proposal_id: {
      readOnly: true,
    },
    date_paid: {
      type: 'date',
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    },
    // Derived on the API (amount minus settled charges); writable: false there, so it must
    // never leave the client in a PATCH.
    amount_remaining: {
      readOnly: true,
    },
  },
  relationships: {
    proposal: {
      type: 'proposals',
    },
    items: {
      type: 'payment_items',
    },
    // Split-payment ledger (RPD-17338). Read via `include: 'charges'`; every attribute is
    // read-only on the API, so the relationship is stripped from writes as well.
    charges: {
      type: 'payment_charges',
      readOnly: true,
    },
  },
}
